import { useMemo, useState, useEffect, useRef } from 'react';

import i18next from 'i18next';
import { Modal, Button, Select } from '@scuf/common';
import './OrganisationList-theme.scss';
import './GatewayOrganisationList.scss';

const GatewayIdleTime = () => {
	const [isIdle, setIsIdle] = useState(false);
    const idleTimeoutRef = useRef<NodeJS.Timeout | null>(null);
    const popupTimeout = 30 * 60 * 1000; // 30 minutes in milliseconds

	const resetIdleTimer = () => {
        if (idleTimeoutRef.current) {
            clearTimeout(idleTimeoutRef.current);
        }
        idleTimeoutRef.current = setTimeout(() => {
            setIsIdle(true);
        }, popupTimeout);
    };

    useEffect(() => {
        const events = ['mousemove', 'keydown', 'mousedown', 'touchstart'];
        events.forEach(event => window.addEventListener(event, resetIdleTimer));

        resetIdleTimer(); // Initialize the idle timer

        return () => {
            if (idleTimeoutRef.current) {
                clearTimeout(idleTimeoutRef.current);
            }
            events.forEach(event => window.removeEventListener(event, resetIdleTimer));
        };
    }, []);

    const handlePopupClose = () => {
        setIsIdle(false);
        resetIdleTimer(); // Reset the idle timer when the popup is closed
    };

	const handleRefresh = () => {
        window.location.reload(); // Reload the page
    };


	const renderIdlePopUp = () => {
        return (
            <Modal
                className='gateway-org-confirm-modal-cls'
                open={isIdle}
                size='small'
            >
                <Modal.Header></Modal.Header>
                <Modal.Content>
					{i18next.t('gatewayIdleMessage')}
                </Modal.Content>
                <Modal.Footer>
					<Button
                        content={i18next.t('refresh')}
                        className='gateway-org-btn-cls gateway-org-refresh-btn-cls'
                        onClick={handleRefresh}
                    />
                </Modal.Footer>
            </Modal>
        );
    };

	return (
		<>
			{renderIdlePopUp()}

		</>
	);
};

export default GatewayIdleTime;